<script lang="ts" setup>
  definePage({
    meta: {
      public: true,
    },
  })
</script>

<template>
  <v-empty-state
    headline="Whoops, 404"
    image="@/assets/logo/full.svf"
    text="The page you were looking for does not exist"
    title="Page not found"
  />
</template>

<style lang="scss">
</style>
